export { createIdentifier } from './decorators';
export { setDependencies } from './dependencyDeclare';
export { forwardRef } from './dependencyForwardRef';
export { isAsyncDependencyItem, isAsyncHook, isClassDependencyItem, isCtor, isFactoryDependencyItem, isValueDependencyItem, } from './dependencyItem';
export { Self, SkipSelf } from './dependencyLookUp';
export { Inject, Many, Optional } from './dependencyQuantity';
export { WithNew } from './dependencyWithNew';
export { isDisposable } from './dispose';
export { RediError } from './error';
export { Injector } from './injector';
export { LookUp, Quantity } from './types';
var globalObject = (typeof globalThis !== 'undefined' && globalThis)
    || (typeof window !== 'undefined' && window)
    // eslint-disable-next-line no-restricted-globals
    || (typeof global !== 'undefined' && global);
var __REDI_GLOBAL_LOCK__ = 'REDI_GLOBAL_LOCK';
// eslint-disable-next-line node/prefer-global/process
var isNode = typeof process !== 'undefined' && process.versions != null && process.versions.node != null;
if (globalObject[__REDI_GLOBAL_LOCK__]) {
    if (!isNode) {
        console.error("[redi]: You are loading scripts of redi more than once! This may cause undesired behavior in your application.\nMaybe your dependencies added redi as its dependency and bundled redi to its dist files. Or you import different versions of redi.\nFor more info please visit our website: https://redi.wendell.fun/en-US/docs/debug#import-scripts-of-redi-more-than-once");
    }
}
else {
    globalObject[__REDI_GLOBAL_LOCK__] = true;
}
//# sourceMappingURL=publicApi.js.map